import Home from "./pages/Home.jsx";
import MedicalLayout from "./pages/medical/MedicalLayout.jsx";
import InsightsPage from "./pages/medical/InsightsPage.jsx";
import InsightDetailPage from "./pages/medical/InsightDetailPage.jsx";
import SuccessStoriesPage from "./pages/medical/SuccessStoriesPage.jsx";
import ServiceDetailPage from "./pages/medical/ServiceDetailPage.jsx";
import RecruitmentProcessPage from "./pages/medical/RecruitmentProcessPage.jsx";
import FaqPage from "./pages/medical/FaqPage.jsx";
import CandidateJourneyPage from "./pages/medical/CandidateJourneyPage.jsx";
import CandidateFeedbackPage from "./pages/medical/CandidateFeedbackPage.jsx";
import FaqCandidatesPage from "./pages/medical/FaqCandidatesPage.jsx";
import CaseStudiesPage from "./pages/medical/CaseStudiesPage.jsx";
import HistoryPage from "./pages/medical/HistoryPage.jsx";
import AGBPage from "./pages/medical/AGBPage.jsx";
import DatenschutzPage from "./pages/medical/DatenschutzPage.jsx";
import ImpressumPage from "./pages/medical/ImpressumPage.jsx";
import TeamPage from "./pages/medical/TeamPage.jsx";
import AwardsPage from "./pages/medical/AwardsPage.jsx";
import BesetztePositionenPage from "./pages/medical/BesetztePositionenPage.jsx";
import SocialResponsibilityPage from "./pages/medical/SocialResponsibilityPage.jsx";
import KarrierePage from "./pages/medical/KarrierePage.jsx";
import MedicalNotFoundPage from "./pages/medical/MedicalNotFoundPage.jsx";
import MagazinesPage from "./pages/medical/MagazinesPage.jsx";
import SalesLayout from "./pages/sales/SalesLayout.jsx";
import SalesStoryPage from "./pages/sales/SalesStoryPage.jsx";
import SalesTeamPage from "./pages/sales/SalesTeamPage.jsx";
import SalesServiceDetailPage from "./pages/sales/SalesServiceDetailPage.jsx";
import NotFoundPage from "./pages/NotFoundPage.jsx";

export const routes = [
  { path: "/", element: <Home /> },
  {
    path: "/medical",
    element: <MedicalLayout />,
    children: [
      { path: "insights", element: <InsightsPage /> },
      { path: "insights/:slug", element: <InsightDetailPage /> },
      { path: "suchmethode", element: <ServiceDetailPage /> },
      { path: "executive-search", element: <ServiceDetailPage /> },
      { path: "praxisnachfolger-suche", element: <ServiceDetailPage /> },
      { path: "referenzen", element: <SuccessStoriesPage /> },
      { path: "garantien", element: <ServiceDetailPage /> },
      { path: "soziale-verantwortung", element: <SocialResponsibilityPage /> },
      { path: "rekrutierungsprozess", element: <RecruitmentProcessPage /> },
      { path: "faq", element: <FaqPage /> },
      { path: "kandidatenreise", element: <CandidateJourneyPage /> },
      { path: "karriere", element: <KarrierePage /> },
      { path: "kandidatenfeedback", element: <CandidateFeedbackPage /> },
      { path: "faq-kandidaten", element: <FaqCandidatesPage /> },
      { path: "fallstudien", element: <CaseStudiesPage /> },
      { path: "geschichte", element: <HistoryPage /> },
      { path: "team", element: <TeamPage /> },
      { path: "besetzte-positionen", element: <BesetztePositionenPage /> },
      { path: "auszeichnungen", element: <AwardsPage /> },
      { path: "magazine", element: <MagazinesPage /> },
      { path: "impressum", element: <ImpressumPage /> },
      { path: "agb", element: <AGBPage /> },
      { path: "datenschutz", element: <DatenschutzPage /> },
      { path: "*", element: <MedicalNotFoundPage /> },
    ],
  },
  {
    path: "/sales",
    element: <SalesLayout />,
    children: [
      { path: "geschichte", element: <SalesStoryPage /> },
      { path: "team", element: <SalesTeamPage /> },
      { path: "insights", element: <InsightsPage /> },
      { path: "insights/:slug", element: <InsightDetailPage /> },
      { path: "referenzen", element: <SuccessStoriesPage /> },
      { path: "awards", element: <AwardsPage /> },
      { path: "magazine", element: <MagazinesPage /> },
      { path: "sales-klassisch", element: <SalesServiceDetailPage /> },
      { path: "sales-industrie", element: <SalesServiceDetailPage /> },
      { path: "sales-healthcare", element: <SalesServiceDetailPage /> },
      { path: "impressum", element: <ImpressumPage /> },
      { path: "agb", element: <AGBPage /> },
      { path: "datenschutz", element: <DatenschutzPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
];
